import { useTranslation } from "@redotech/redo-i18n";
import ArrowUpRightIcon from "@redotech/redo-icons/arrow-circle-up-right.svg";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { memo } from "react";
import { DecryptedText } from "./decrypted-text";

function getLoginUrl(): string {
  const next = encodeURIComponent("/onboarding-redirect");
  if (typeof window === "undefined") {
    return `https://app.getredo.com/login?next=${next}`;
  }
  const hostname = window.location.hostname;
  if (hostname === "localhost") {
    return `http://localhost:13003/login?next=${next}`;
  }
  if (hostname.endsWith(".getredo.localhost")) {
    return `https://app-vite.getredo.localhost/login?next=${next}`;
  }
  return `https://app.getredo.com/login?next=${next}`;
}

const LOGIN_URL = getLoginUrl();

const noop = () => {};

export const LoginModal = memo(function LoginModal() {
  const { t } = useTranslation();
  return (
    <RedoModal
      disableBackdropClose
      disableEscapeClose
      hideCloseButton
      modalSize="sm"
      onModalCloseRequested={noop}
      primaryButton={{
        text: t("Log in"),
        IconTrailing: ArrowUpRightIcon,
        onClick: () => window.location.assign(LOGIN_URL),
      }}
      subtitle={t(
        "Your setup session has expired. Log back into Redo, click your profile icon in the bottom left, and re-initiate a setup session.",
      )}
      title={
        <DecryptedText sequential speed={60} text={t("Session expired")} />
      }
    />
  );
});
